import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'ad-grid',
  name: '广告魔方',
  icon: '广',
  group: '营销组件',
  description: '以五种固定版式展示广告入口',
  defaultProps: {
    layoutMode: 'SINGLE',
    items: []
  }
}
